"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tailwind_1 = require("../constants/tailwind");
var slider_1 = require("../modules/slider");
var get_element_1 = require("../utils/get_element");
var IDS = {
    SEARCH_TAB_BUTTON: 'js-contents-search-tab-button',
    ORDER_MADE_TAB_BUTTON: 'js-order-made-tab-button',
    SEARCH_TAB: 'js-contents-search-tab',
    ORDER_MADE_TAB: 'js-order-made-tab',
};
/**
 * タブの切り替えイベントを初期化
 */
var initTabSwitchEvent = function () {
    var searchTabButton = (0, get_element_1.getElementById)(IDS.SEARCH_TAB_BUTTON);
    var orderMadeTabButton = (0, get_element_1.getElementById)(IDS.ORDER_MADE_TAB_BUTTON);
    var searchTab = (0, get_element_1.getElementById)(IDS.SEARCH_TAB);
    var orderMadeTab = (0, get_element_1.getElementById)(IDS.ORDER_MADE_TAB);
    // 検索タブボタンにクリックイベントを追加
    searchTabButton.addEventListener('click', function () {
        searchTabButton.classList.add(tailwind_1.TAILWIND_CLASSES.TOP_TAB_BUTTON_ACTIVE);
        orderMadeTabButton.classList.remove(tailwind_1.TAILWIND_CLASSES.TOP_TAB_BUTTON_ACTIVE);
        searchTab.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        orderMadeTab.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    });
    // オーダーメイドタブボタンにクリックイベントを追加
    orderMadeTabButton.addEventListener('click', function () {
        orderMadeTabButton.classList.add(tailwind_1.TAILWIND_CLASSES.TOP_TAB_BUTTON_ACTIVE);
        searchTabButton.classList.remove(tailwind_1.TAILWIND_CLASSES.TOP_TAB_BUTTON_ACTIVE);
        orderMadeTab.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        searchTab.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    });
};
/**
 * スライダーの初期化
 */
var initSlider = function () {
    var options = window.eccube.isLoggedIn
        ? {
            loop: true,
            slides: { perView: 2, spacing: 40 },
            breakpoints: {
                '(max-width: 769px)': {
                    slides: {
                        perView: 1,
                    },
                },
            },
        }
        : { loop: true };
    (0, slider_1.setupSlider)(options);
};
initTabSwitchEvent();
initSlider();
